<template>
	<div class="container product-container">
		<productDetail :banner="banner" :memStoreInfo="memStoreInfo" :productId="productId" :productInfo="productInfo" :productGuaranteeList="productGuaranteeList" ref="productDetail" @func="funcs"></productDetail>
		<!--底部操作栏-->
		<div class="tui-operation">
			<div class="tui-operation-left">
				<div class="tui-operation-item" @click="collect">
					<img src="@/assets/icon/icon_heart.png" v-if="productInfo.isFavoriteProduct=='0' || !productInfo.isFavoriteProduct" @click="follows"/>
					<van-icon name="like" color="var(--theme-color-main)" size="20px"  @click="follows" v-else/>
					<div class="tui-operation-text">收藏</div>
				</div>
				<div class="tui-operation-item" @click="goCart">
					<img src="@/assets/icon/icon_cart.png" />
					<div class="tui-operation-text">购物车</div>
					<span class="cart-num" v-if="cartNum && cartNum > 0">{{cartNum}}</span>
				</div>
			</div>
			<div class="margin-right-xs flex">
				<van-button plain round block color="#979797" type="primary" @click="submit" v-if="productInfo.pickFlag !='1'" class="b-button">加入购物车</van-button>
				<van-button round block color="var(--theme-color-main)" type="primary" @click="submit" class="b-button">立即购买</van-button>
			</div>
		</div>
	</div>
</template>

<script>
	import wx from 'weixin-js-sdk'
	import {getProductInfo,userCartNum} from "../../api/api";
	import productDetail from "@/components/product/productDetailItem.vue";
	export default {
		components: {
			productDetail
		},
		data() {
			return {
				popupMent:true,
				popupAddress:false,//地址弹出addApplets
				guarantee:false,//服务弹出
				productStatus:['商品介绍','商品参数','包装售后'],//商品详情类型
				productStatusIndex:0,//商品详情类型默认
				addressIndex:0, //地址默认
				banner: [],
				productInfo:{},
				bannerIndex: 0,
				menuShow: false,
				popupShow: false,
				value: 1,
				collected: false,
				productId:this.$route.query.id,
				productGuaranteeList:[],
				memStoreInfo:{},
				cartNum:null,
			};
		},
		created:function(){
			if(this.$route.query.token){
				this.$cookies.set('token',this.$route.query.token);
			}
		},
		mounted: function(options) {
			if(this.$route.query.token){
				this.$cookies.set('token',this.$route.query.token);
			}
			// 如果支持 popstate 一般移动端都支持了
			// if (window.history && window.history.pushState) {
			// 	// 往历史记录里面添加一条新的当前页面的url
			// 	history.pushState(null, null, document.URL);
			// 	// 给 popstate 绑定一个方法 监听页面刷新
			// 	window.addEventListener('popstate', this.backChange, false);//false阻止默认事件
			// }
			this.getProduct();
			this.userCartNum();
		},
		// destroyed(){
		// 	window.removeEventListener('popstate', this.backChange, false);//false阻止默认事件
		// },
		methods: {
			// 商品数量
			async userCartNum() {
				const res = await userCartNum();
				if (res.code == "0000") {
					// this.$store.commit("setCartNum", res.data.num);
					this.cartNum = res.data;
				} else {
					this.$toast(res.msg);
				}
			},
			// backChange(){
			// 	// wx.miniProgram.switchTab({
			// 	// 	url: '/pages/index/index'
			// 	// })
			// },
			funcs(e){
				this.productInfo.isFavoriteProduct=e
			},
			// 获取数据
			async getProduct() {
				var id=this.$route.query.id
				const params = {
					id: id?id:26,
					// promotionId: 1,
					// productType:1
				};
				const res = await getProductInfo(params);
				if (res.code === "0000") {
					if(res.data.memStoreInfo){
						this.memStoreInfo=res.data.memStoreInfo;
					}
					this.banner = res.data.productMedia; //商品主图
					this.productInfo = res.data.productInfo; //商品信息
					this.productInfo['describe']=JSON.parse(res.data.productInfo.describe);
					if(res.data.productGuaranteeList){
						this.productGuaranteeList = res.data.productGuaranteeList; //商品信息
					}
				} else {

					this.$toast(res.msg);
				}
			},
			showSkuGroup() {
				var sty = document.getElementById("hideSkuGroup");
				if (sty) {
					sty.remove();
				}
			},
			//商品图
			bannerChange: function(e) {
				this.bannerIndex = e;
			},
			previewimg: function(e) {


			},
			closeMenu: function() {
				this.menuShow = false;
			},
			showPopup: function() {
				this.popupShow = true;
			},
			change: function(e) {
				this.value = e.value;
			},
			collect: function() {
				this.collected = !this.collected;
			},
			//购物车
			goCart: function() {
				wx.miniProgram.switchTab({
					url: '/pages/cart/cart'
				})
			},
			//立即购买
			submit() {
				this.$refs.productDetail.showSKuFun();
			},
			follows(){
				this.$refs.productDetail.follow(this.productInfo.isFavoriteProduct);
			}
		}
	};
</script>

<style lang="scss" scoped>
.product-container {
	padding-bottom: 110px;
	background-color: #f1f1f1;
}
/*底部操作栏*/
.tui-operation {
	width: 100%;
	background: #ffffff;
	position: fixed;
	display: flex;
	align-items: center;
	justify-content: space-between;
	z-index: 10;
	bottom: 0;
	left: 0;
	padding: 12px 0;
	.tui-operation-left {
		display: flex;
		align-items: center;
	}
	.tui-operation-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
		width:120px;
		img {
			height: 36px;
			width: 38px;
		}
		.cart-num{
			background: $theme-color-main;
			color: #ffffff;
			border-radius: 20px;
			padding: 2px 10px;
			position: absolute;
			top: -10px;
			right: 15px;
			font-size: 14px;
		}
	}
	.tui-operation-text {
		font-size: 24px;
		color: #666666;
	}
	.b-button{
		width: 226px;
		margin-right: 10px;
	}
}
/*底部操作栏*/
</style>
